import { render, staticRenderFns } from "./ServicesGrid.vue?vue&type=template&id=a1adaa04&scoped=true"
import script from "./ServicesGrid.vue?vue&type=script&lang=js"
export * from "./ServicesGrid.vue?vue&type=script&lang=js"
import style0 from "./ServicesGrid.vue?vue&type=style&index=0&id=a1adaa04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1adaa04",
  null
  
)

export default component.exports